<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'UcContractPaymentTermsEditor',
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    value: {
      type: Object,
      required: false,
    },
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const contractPaymentTermTypes = ref(null);
  const ux = ref([]);

  const $data = computed(() => ({
    contractPaymentTermTypes: contractPaymentTermTypes.value,
    ux: ux.value,
  }));

  const $$load_contractPaymentTermTypes = async () => {
    return $fn.value.getEnumValuesFromSchema('ContractPaymentTermTypes');
  };

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [{ name: 'contractPaymentTermTypes' }, { name: 'ux' }],
    loaders: { contractPaymentTermTypes: $$load_contractPaymentTermTypes },
    ux: {},
    dataRefs: { contractPaymentTermTypes, ux },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  watch(
    () => props.value,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('value');
    }
  );

  const act_7315092382398562_reloadComponentData_1sf94184i =
    new actionTypes.ReloadComponentDataAction({});
  const inst_evh_7315092382398562_reload_g9hiavbu0 =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_reloadComponentData_1sf94184i,
      event: 'reload',
      displayName: 'reloadComponentData',
    });
  const inst_evh_7315092382398562_reload = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_reload_g9hiavbu0],
    event: 'reload',
  });

  const actions = {
    inst_evh_7315092382398562_reload_g9hiavbu0,
    inst_evh_7315092382398562_reload,
  };

  const evh_7315092382398562_reload_g9hiavbu0 = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload_g9hiavbu0.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpUsercontrol
    :loading="loading"
    :reloading="reloading"
    :loaded="loaded"
    :error="error"
    @reload="evh_7315092382398562_reload($event, {})"
  >
    <div class="input-group">
      <ItpFormInput
        type="number"
        name="payment_terms_value"
        v-model="value.value"
        :value="value.value"
        @input="
          !($event && typeof $event.stopPropagation === 'function') &&
          (value.value =
            $event && typeof $event === 'object' && 'data' in $event
              ? $event.data
              : $event)
        "
      >
      </ItpFormInput>
      <ItpFormSelect2
        name="payment_terms_type"
        v-model="value.type"
        :value="value.type"
        @input="
          !($event && typeof $event.stopPropagation === 'function') &&
          (value.type =
            $event && typeof $event === 'object' && 'data' in $event
              ? $event.data
              : $event)
        "
        :options="contractPaymentTermTypes"
      >
      </ItpFormSelect2>
    </div>
  </ItpUsercontrol>
</template>
